import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static values = {
    loadingPath: String,
    finishedPath: String,
    resultPath: String,
    shouldPoll: Boolean,
    maxPoll: 10,
  };
  static targets = ["pollingDone", "pollLoadingFrame", "pollResultFrame"];

  connect() {
    this.currentPoll = 0;
    if (!this.shouldPollValue) {
      return;
    }
    this.poller = setInterval(() => {
      this.loadFrame(this.pollLoadingFrameTarget, this.loadingPathValue);
      this.currentPoll += 1;
      if (this.currentPoll > this.maxPollValue) {
        this.loadFrame(this.pollLoadingFrameTarget, this.finishedPathValue);
        this.stopPolling();
      }
    }, 1000);
  }

  pollingDoneTargetConnected() {
    this.stopPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  stopPolling() {
    if (!this.shouldPollValue) {
      return;
    }

    clearInterval(this.poller);
    this.loadFrame(this.pollResultFrameTarget, this.resultPathValue);
  }

  loadFrame(frame, path) {
    frame.setAttribute("src", null);
    frame.setAttribute("src", path);
  }
}
